import { useQuery, useQueryClient } from "@tanstack/react-query";
import LabelledDivRow from "components/LabelledDivRow";
import { Loading } from "components/panels";
import React from "react";

const UserTaskRows = () => {
  const emailHealthQuery = useQuery({
    queryFn: async () => window.CoreApi.UserTask.ReminderHealth("email").then(r => r.data),
    queryKey: ["userTaskHealth", "email"]
  });

  const popupHealthQuery = useQuery({
    queryFn: async () => window.CoreApi.UserTask.ReminderHealth("popup").then(r => r.data),
    queryKey: ["userTaskHealth", "popup"]
  });

  const queryClient = useQueryClient();

  const onRefresh = async () => queryClient.invalidateQueries(["userTaskHealth"]);

  const anyErrors = emailHealthQuery.isError || popupHealthQuery.isError ||
    emailHealthQuery.data?.hasErrors || popupHealthQuery.data?.hasErrors;
  const anyFetching = emailHealthQuery.isFetching || popupHealthQuery.isFetching;

  if (anyErrors) return <div>Error loading user task health</div>;
  if (anyFetching) return <Loading />;

  const { isQueued: popupIsQueued, pendingTrigger: popupPendingTrigger, preQueue: popupPrequeue, sent: popupSent } = popupHealthQuery.data.data;
  const { isQueued: emailIsQueued, pendingTrigger: emailPendingTrigger, preQueue: emailPrequeue, sent: emailSent } = emailHealthQuery.data.data;

  const items = [{
    label: "Popup isQueued",
    count: popupIsQueued
  },
  {
    label: "Popup pendingTrigger",
    count: popupPendingTrigger
  },
  {
    label: "Popup preQueue",
    count: popupPrequeue
  },
  {
    label: "Popup sent",
    count: popupSent
  },
  {
    label: "Email isQueued",
    count: emailIsQueued
  },
  {
    label: "Email pendingTrigger",
    count: emailPendingTrigger
  },
  {
    label: "Email preQueue",
    count: emailPrequeue
  },
  {
    label: "Email sent",
    count: emailSent
  }];

  const nothingToShow = items.every(i => i.count === 0);

  return <>
    {nothingToShow && <LabelledDivRow label="Nothing"></LabelledDivRow>}

    {items.filter(i => i.count > 0).map(i =>
      <LabelledDivRow key={i.label} label={i.label}>
        <div>{i.count}</div>
      </LabelledDivRow>
    )}

    <LabelledDivRow label="">
      <a onClick={onRefresh}>Refresh</a>
    </LabelledDivRow>
  </>;
};

export default UserTaskRows;